export default function isAuthenticated() {
  // Check whether the current time is past the
  const urlParams = new URLSearchParams(window.location.search);
  console.log(urlParams);
  const myParam = urlParams.get('code');
  console.log(myParam);
  // access token's expiry time
  let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
  return new Date().getTime() < expiresAt;
}